<template>
  <div>
    <!-- floating button, but make sure there's enough space at 
        the bottom for it not to hide anything -->

    <v-card :loading="loading" flat tile>

      <v-card-title>
        Update User
        <v-spacer></v-spacer>
        <v-btn
          class="ml-1 mr-1"
          color="warning"
          small
          @click="getUserDetails"
          v-if="showInDev"
        >
          Reload page
        </v-btn>
        <v-btn
          class="ml-1 mr-1"
          color="primary"
          small
          @click="resendInvitationMail()"
        >
          Resend invitation email
        </v-btn>
        <v-btn class="ml-1 mr-1" color="error" small @click="deleteItem(false)" v-if="!loading && !user.deleted">
          Remove User
        </v-btn>
        <v-btn class="ml-1 mr-1" color="error" small @click="deleteItem(true)" v-else-if="!loading">
          Reactivate User
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col
            cols="12"
            sm="6"
            :class="$vuetify.breakpoint.smAndUp ? 'pr-2' : ''"
          >
            <v-text-field
              class="mt-2 mb-2 required"
              dense
              label="First Name"
              clearable
              v-model="user.firstName"
              :rules="[$common.rules.required]"
              hide-details="auto"
              outlined
              no-gutters
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              class="mt-2 mb-2 required"
              dense
              label="Last Name"
              clearable
              v-model="user.lastName"
              :rules="[$common.rules.required]"
              hide-details="auto"
              no-gutters
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            :class="$vuetify.breakpoint.smAndUp ? 'pr-2' : ''"
          >
            <v-text-field
              class="mt-2 mb-2"
              dense
              label="Job Title"
              clearable
              v-model="user.jobTitle"
              hide-details="auto"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              class="mt-2 mb-2"
              dense
              label="Organisation"
              v-model="user.organisationId"
              :items="user.availableOrganisations"
              outlined
              clearable
              no-gutters
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-alert v-if="warningMessage" type="warning" outlined text border="left">{{ warningMessage }}</v-alert>
          </v-col>
          <v-col cols="3">
                <v-checkbox
                  class="mt-0 mb-2"
                  no-gutters
                  dense
                  label="Distribution New ESV Receiver"
                  v-model="user.isDistributionReceiver"
                  hide-details="auto"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  class="mt-0 mb-2"
                  no-gutters
                  dense
                  label="Distribution New RNS Receiver"
                  v-model="user.isDistributionReceiverRns"
                  hide-details="auto"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  class="mt-0 mb-2"
                  no-gutters
                  dense
                  label="Distribution Update ESV Receiver"
                  v-model="user.isDistributionReceiverUpdate"
                  hide-details="auto"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  class="mt-0 mb-2"
                  no-gutters
                  dense
                  label="Distribution Update RNS Receiver"
                  v-model="user.isDistributionReceiverUpdateRns"
                  hide-details="auto"
                ></v-checkbox>
              </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card flat outlined>
              <v-card-title
                class="blue lighten-4 pt-1 pb-1"
                style="word-break: break-word"
              >
                <v-icon color="blue">mdi-flag</v-icon>
                Product Groups user will receive Distribution email for
                <v-spacer></v-spacer>
                <v-checkbox
                  class="mt-2 mb-2"
                  no-gutters
                  dense
                  v-model="selectAllProductGroups"
                  :label="selectAllProductGroupsLabel"
                  hide-details="auto"
                ></v-checkbox>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-for="productGroup in user.allAvailableProductGroups"
                    :key="productGroup.value + '-' + productGroup.text"
                    class="pa-0"
                    no-gutters
                  >
                    <v-checkbox
                      multiple
                      dense
                      no-gutters
                      v-model="productGroupConcatenation"
                      :label="productGroup.text"
                      :value="productGroup.value"
                      hide-details="auto"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            cols="12"
            sm="6"
            :class="$vuetify.breakpoint.smAndUp ? 'pr-2' : ''"
          >
            <v-text-field
              class="mt-2 mb-2 required"
              dense
              label="Email"
              disabled
              :aria-disabled="'Email: ' + user.email"
              v-model="user.email"
              hide-details="auto"
              outlined
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              class="mt-2 mb-2"
              dense
              label="Password"
              clearable
              :rules="[user.password ? $common.rules.password : true]"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility_off' : 'visibility'"
              @click:append="() => (showPassword = !showPassword)"
              v-model="user.password"
              hide-details="auto"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              dense
              label="Language"
              v-model="user.supportedCultureId"
              :items="user.availableSupportedCultures"
              hide-details="auto"
              outlined
              clearable
              no-gutters
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card flat tile>
      <v-card-title>
        Authentication method
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-select 
              v-model="user.authenticationMethod" 
              :items="authenticationMethods" 
              label="Authentication method"
              dense hide-details="auto" outlined
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card :loading="loading" flat tile>
      <v-card-title class="pt-1 pb-1"> Permissions </v-card-title>
      <v-card-text v-if="user.permissions && user.permissions.availableRoles">
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" sm="9">
                <v-autocomplete
                  dense
                  label="Role"
                  v-model="user.permissions.permissionRoleId"
                  :items="user.permissions.availableRoles"
                  hide-details="auto"
                  outlined
                  clearable
                  no-gutters
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-btn
                  class="ml-1 mr-1"
                  width="100%"
                  color="primary"
                  @click="addRole"
                >
                  Add
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-card :color="error.roles ? 'error' : 'white'">
              <v-card-title class="pt-1 pb-1"> Assigned Permissions</v-card-title>
              <v-card-text>
                <v-data-table dense :headers="headerRoles" :items="user.roles">
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon color="red" @click="deleteRole(item)">
                      <v-icon
                        class="mr-2"
                      >
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <floating-button
      @click="updateUser"
      :loading="loading"
      fab
    >
      <v-icon>mdi-content-save</v-icon>
    </floating-button>
  </div>
</template>

<script>
import FloatingButton from '@/components/common/FloatingButton.vue';
export default {
  components: { FloatingButton },
  props: {
    userId: {
      typeof: Number,
      required: true,
    },
  },
  data: () => ({
    // selectAllProductGroups: false,
    showPassword: false,
    showInDev: false,
    loading: false,
    error: { roles: false },
    user: { productGroupConcatenation: "" },
    productGroupConcatenation: [],
    roleVModel: null,
    headerRoles: [
      {
        text: "Role",
        align: "start",
        sortable: true,
        value: "name",
      },
      { text: "", value: "actions", sortable: false },
    ],
    warningMessage: null,
    authenticationMethods: [
      { text: 'Daikin Active directory', value: 0 },
      { text: 'DIL Active Directory', value: 1 },
      { text: 'Local authentication', value: 2 },
      { text: 'CDC', value: 3 }
    ]
  }),
  computed: {
    selectAllProductGroups: {
      get: function () {
        let selectedLength = this.productGroupConcatenation
          ? this.productGroupConcatenation.length
          : 0;
        let availableLength = this.user.allAvailableProductGroups
          ? this.user.allAvailableProductGroups.length
          : 1;
        if (selectedLength == availableLength) {
          return true;
        }
        return false;
      },
      set: function (selectAll) {
        this.toggleProductGroupSelection(selectAll);
      },
    },
    selectAllProductGroupsLabel() {
      if (this.selectAllProductGroups) {
        return "unselect all Product Groups";
      }
      return "select all Product Groups";
    },
  },
  methods: {
    getUserDetails() {
      this.loading = true;
      this.$api
        .getUserDetails(this.userId)
        .then((resp) => {
          this.user = resp.data;
          this.productGroupConcatenation = [];
          this.user.productGroupsForNotification.forEach((element) => {
            this.productGroupConcatenation.push(element.value);
          });
          // console.log(resp.data);
        })
        .finally(() => (this.loading = false));
    },
    reactivateUser(){
      this.user.deleted = false;
      this.updateUser();
    },
    updateUser() {
      var testString = this.fromArrayToString(this.productGroupConcatenation);
      // console.log(testString);
      this.user.productGroupConcatenation = testString;
      // console.log(this.error.roles);
      if (this.user.roles.length > 0) {
        this.error.roles = false;
        // console.log(this.error);
        // console.log(this.user);
        this.loading = true;
        this.$api
          .updateUser(this.user)
          .then((resp) => {
            // console.log(resp.data);
              this.$toast.success(resp.data);
              this.$router.push({name: "Users"});
          })
          .catch(() => {})
          .finally(() => (this.loading = false));
      } else {
        this.error.roles = true;
      }
    },
    fromArrayToString(array) {
      var output = "";
      if (array != null && array.length > 0) {
        for (const value of array) {
          output += output == "" ? value : "," + value;
        }
      }
      return output;
    },
    toggleProductGroupSelection(selectAll) {
      //   console.log(selectAll);
      if (selectAll) {
        // this.user.productGroupConcatenation = null;
        if (this.productGroupConcatenation == null) {
          this.productGroupConcatenation = new Array();
        }
        this.user.allAvailableProductGroups.forEach((productGroup) => {
          if (
            this.productGroupConcatenation.indexOf(productGroup.value) == -1
          ) {
            this.productGroupConcatenation.push(productGroup.value);
          }
        });
        // console.log(true);
      } else {
        this.productGroupConcatenation = null;
      }
    },
    resendInvitationMail() {
      this.$api
        .resendInvitationMail(this.userId)
        .then(() => {
          this.$toast.success("Invitation mail sent");
        })
        .catch(() => {
          this.$toast.error("Invitation mail was not sent.");
        });
    },
    deleteItem(reactivate) {
      let confirmMessage = reactivate ? 'reactivate ' : 'delete '
      this.$confirm('Are you sure you wish to ' + confirmMessage + this.user.firstName + ' ' + this.user.lastName + '?')
        .then(res => {
          if (res) {
            this.$api
              .deleteUser(this.userId, reactivate)
              .then(() => {
                let successMessage = reactivate ? "reactivated" : "deleted";
                this.$toast.success("User "  + this.user.firstName + ' ' + this.user.lastName + " has been " + successMessage);
                if (!reactivate){
                  this.$router.push({ name: "Users" });
                }
                else if (!this.user.organisationId){
                  this.warningMessage = 'Please check the organisation for this user';
                }
              })
          }
        })
    },
    deleteRole(item) {
      // console.log(item)
      let indexOfItem = this.user.roles.indexOf(item);
      let tempArray = this.user.roles.slice(0, indexOfItem);
      let tempArray2 = this.user.roles.slice(indexOfItem + 1);

      this.user.roles = tempArray.concat(tempArray2);
      // console.log(this.user.roles);
    },
    addRole() {
      if (this.user.permissions.permissionRoleId != "0") {
        let item = this.user.permissions.availableRoles.find(
          ({ value }) => value === this.user.permissions.permissionRoleId
        );
        let role = { id: item.value, name: item.text };
        let testing = this.user.roles.some((r) => r.id == role.id);
        if (!testing) {
          this.user.roles.push(role);
        }
      }
    }
  },

  created() {
    if (this.userId == null) {
      this.$router.push({ name: "Users" });
    }
  },

  mounted() {
    if (this.userId != null) {
      this.getUserDetails();
    }
  },
};
</script>

<style scoped>
</style>